'use client';

import { useEffect } from 'react';
import { ethers } from 'ethers';

export default function ReferralHandler(): null {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref && ethers.isAddress(ref)) {
      try {
        localStorage.setItem('referralAddress', ref);
      } catch (e) {
        console.error('Failed to store referral address', e);
      }
    }
  }, []);
  return null;
}

